/* ==========================================================================
   OBAÏA Paris — Modale de recherche (Nelson, Figma 834:7886 / 834:8092)
   - s'ouvre au clic sur la loupe de l'en-tête (liens vers /search) ou sur [data-recherche-ouvrir] ;
   - curseur directement dans le champ ; dès 2 lettres, recherche prédictive Shopify
     (/search/suggest, rendu par la section obaia-recherche-suggest), 200 ms après la dernière frappe ;
   - Échap, la croix ou le voile ferment ; le focus reste dans la modale (Tab) et revient à la loupe.
   ========================================================================== */
(function () {
  'use strict';
  var d = document, modale, champ, produits, pages, pagesDefaut, effacer, retour, minuterie, requete, cache = {};
  var header = function () { return d.querySelector('[data-header]') || d.querySelector('.header'); };

  function placer() {
    var h = header(), top = 0;
    if (h) { var b = h.getBoundingClientRect().bottom; top = Math.max(0, Math.round(b)); }
    modale.style.setProperty('--rch-top', top + 'px');
  }

  function ouvrir(e) {
    if (e) e.preventDefault();
    retour = d.activeElement;
    modale.hidden = false;
    placer();
    var h = header(); if (h) h.classList.add('is-recherche');
    d.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () { requestAnimationFrame(function () { modale.classList.add('is-open'); }); });
    champ.focus();
    if (champ.value.trim().length >= 2) chercher();
  }

  function fermer() {
    modale.classList.remove('is-open');
    var h = header(); if (h) h.classList.remove('is-recherche');
    d.documentElement.style.overflow = '';
    setTimeout(function () { modale.hidden = true; }, 350);
    if (retour && retour.focus) retour.focus();
  }

  function afficher(html) {
    var t = d.createElement('div'); t.innerHTML = html;
    var p = t.querySelector('[data-rch-suggest-produits]'), g = t.querySelector('[data-rch-suggest-pages]');
    produits.innerHTML = p ? p.innerHTML : '';
    pages.innerHTML = g && g.innerHTML.trim() ? g.innerHTML : pagesDefaut;
    produits.classList.remove('is-attente');
  }

  function chercher() {
    var q = champ.value.trim();
    effacer.hidden = !champ.value;
    clearTimeout(minuterie);
    if (q.length < 2) { produits.innerHTML = ''; pages.innerHTML = pagesDefaut; return; }
    if (cache[q]) return afficher(cache[q]);
    produits.classList.add('is-attente');
    minuterie = setTimeout(function () {
      if (requete) requete.abort();
      requete = window.AbortController ? new AbortController() : null;
      var url = modale.getAttribute('data-url') + '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,page,article&resources[limit]=6&resources[options][unavailable_products]=last&section_id=obaia-recherche-suggest';
      fetch(url, requete ? { signal: requete.signal } : {})
        .then(function (r) { return r.text(); })
        .then(function (html) { cache[q] = html; if (champ.value.trim() === q) afficher(html); })
        .catch(function () { produits.classList.remove('is-attente'); });
    }, 200);
  }

  function piege(e) {
    if (e.key === 'Escape') { e.preventDefault(); return fermer(); }
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(modale.querySelectorAll('a[href], button:not([hidden]), input:not([type="hidden"])'), function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (e.shiftKey && d.activeElement === a) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && d.activeElement === z) { e.preventDefault(); a.focus(); }
  }

  function init() {
    modale = d.querySelector('[data-recherche]'); if (!modale) return;
    champ = modale.querySelector('[data-recherche-champ]');
    produits = modale.querySelector('[data-recherche-produits]');
    pages = modale.querySelector('[data-recherche-pages]');
    pagesDefaut = pages.innerHTML;
    effacer = modale.querySelector('[data-recherche-effacer]');

    d.addEventListener('click', function (e) {
      var o = e.target.closest('[data-recherche-ouvrir], .header a[href$="/search"], .header a[href*="/search?"]');
      if (o && !e.metaKey && !e.ctrlKey) ouvrir(e);
    });
    modale.querySelectorAll('[data-recherche-fermer]').forEach(function (b) { b.addEventListener('click', fermer); });
    modale.addEventListener('keydown', piege);
    champ.addEventListener('input', chercher);
    effacer.addEventListener('click', function () { champ.value = ''; chercher(); champ.focus(); });
    modale.addEventListener('click', function (e) {
      var m = e.target.closest('[data-recherche-mot]'); if (!m) return;
      e.preventDefault(); champ.value = m.textContent.trim(); chercher(); champ.focus();
    });
    window.addEventListener('resize', function () { if (!modale.hidden) placer(); });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
